import React, { FC } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

interface CircularProgressWithLabelProps {
  value: number | null;
}

export const CircularProgressWithLabel: FC<CircularProgressWithLabelProps> = ({ value }) => {
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex"
      }}>
      <CircularProgress variant="determinate" value={value || 0} />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="textSecondary">
          {value ? `${Math.round(value)}%` : '0'}
        </Typography>
      </Box>
    </Box>
  );
};
